import { LoginAction } from "@/component/login/actions";
import encrypt from "@/tools/encrypt";
import { setLoginUrlCache, setPlatformTokenInfo, Utils } from '@/tools/utils';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, notification } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NumberInput from '../../components/number-input';
import { getMerchantList, getMerchantToken, removeLoginData, setLoginData } from '../../utils';
import { checkExistPhone, validatePhone, validatePhoneRequired } from '../../validator';
import './login-password.less';

const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 }
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 }
};

class LoginPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            btnLoading: false,
            isAgree: false,
        };
    }

    loginSuccess = (data) => {
        const _token = data.token_type + data.access_token;
        let {access_token, token_type, refresh_token, expires_in} = data;
        const _tokenInfo = {
            access_token,
            token_type,
            refresh_token,
            expires_in,
            loginWay: 'newLogin',
            nowTime: Date.parse(new Date()) / 1000
        };
        setPlatformTokenInfo(JSON.stringify(_tokenInfo));
        setLoginUrlCache();//缓存登陆url
        removeLoginData();
        this.props.setToken(_token);
    }

    handleSubmit = async (e) => {
        const search = this.props.history.location.search
        const merchantBelong = new URLSearchParams(search).get('merchantBelong');
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    if(!this.state.isAgree) {
                        notification.warning({
                            message: '请阅读并同意协议',
                        });
                        return;
                    }

                    Utils.customTrack('MerchantLoginClick', {
                        element_content: '登录'
                    });
                    this.setState({
                        btnLoading: true
                    });
                    const params = {
                        phone: values.phone,
                        password: encrypt(values.password)
                    };
                    const res = await getMerchantList(params, 'pwd');
                    if (res.status === 200) {
                        const data = res.data;
                        setLoginData({
                            params: { ...params },
                            loginType: 'pwd',
                            merchants: {
                                list: data.rows,
                                total: data.total
                            },
                            needUnifiedPwd: data.needUnifiedPwd
                        });

                        window.localStorage.setItem('loginType', 'password');
                        localStorage.setItem('subscribeWechat', 'false');
                        const query = merchantBelong ? `?merchantBelong=${merchantBelong}` : ''
                        // 判断是否需要设置统一密码
                        if (data && data.needUnifiedPwd) {
                            this.props.history.push(`/login/unify${query}`);
                            return;
                        }
                        // 判断是否存在多个关联商户，需要选择所登录的商户
                        if (data.total > 1) {
                            this.props.history.push('/login/select' + query);
                            return;
                        } else {
                            const getTokenParams = {
                                ...params,
                                orgId: data.rows[0].orgId
                            }
                            localStorage.setItem('orgId', data.rows[0].orgId);
                            const tokenRes = await getMerchantToken(getTokenParams, 'pwd');
                            console.log('tokenRes',tokenRes );
                            this.loginSuccess(tokenRes.data);
                            this.props.history.replace('/homePage');
                            return;
                        }
                    }
                } finally {
                    this.setState({
                        btnLoading: false
                    });
                }
            }
        });
    }
    render() {
        return (
            <div className="login-password-v5">
                <Form
                    {...layout}
                    onSubmit={this.handleSubmit}
                >
                    <Form.Item>
                        {
                            this.props.form.getFieldDecorator('phone', {
                                validateFirst: true,
                                validateTrigger: !this.props.form.getFieldError('phone') ? 'onBlur' : 'onChange',
                                rules: [
                                    validatePhoneRequired(),
                                    validatePhone(),
                                    {
                                        validator: checkExistPhone
                                    }
                                ],
                            })(
                                <NumberInput size="large" maxLength={11} placeholder="请输入手机号" allowClear />
                            )
                        }
                    </Form.Item>

                    <Form.Item name="password" rules={[{ required: true, message: '请输入登录密码' }]}>
                        {
                            this.props.form.getFieldDecorator('password', {
                                validateFirst: true,
                                validateTrigger: 'onBlur',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入密码'
                                    }
                                ],
                            })(
                                <Input.Password
                                    size="large"
                                    maxLength={20}
                                    placeholder="请输入登录密码"
                                    visibilityToggle={String(this.props.form.getFieldValue('password'))}
                                    allowClear
                                />
                            )
                        }
                    </Form.Item>

                    <div className="checkAgree">
                        <img
                            className="select-icon"
                            src={
                                this.state.isAgree ?
                                    require('../../../img/selected.png') :
                                    require('../../../img/unselect.png')
                            }
                            onClick={() => this.setState({isAgree: !this.state.isAgree})}
                        />
                        {/*<Checkbox.Group>*/}
                        {/*    <Checkbox value={1} />*/}
                        {/*</Checkbox.Group>*/}
                        同意<a href="https://cdn.zhongbaounion.com/share/register/user-agreement.html" target="_blank" onClick={() => {
                            // Utils.customTrack('MerchantLoginClick', {
                            //     element_content: '用户协议'
                            // });
                        }} rel="noreferrer">《用户协议》</a>和<a href="https://cdn.zhongbaounion.com/share/register/privacy-policy.html" target="_blank" onClick={() => {
                            // Utils.customTrack('MerchantLoginClick', {
                            //     element_content: '隐私协议'
                            // });
                        }} rel="noreferrer">《隐私政策》</a>
                    </div>

                    <Form.Item {...tailLayout}>
                        <Button
                            loading={this.state.btnLoading}
                            type="primary"
                            size="large"
                            block
                            htmlType="submit"
                            className="submit-btn"
                        >
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const WrappedForm = Form.create()(LoginPassword);
export default withRouter(connect(null, { ...LoginAction })(WrappedForm));
